export { default } from './ExternalLink'
